/* eslint-disable @typescript-eslint/naming-convention */

// eslint-disable-next-line no-shadow
export enum ESortingActions {
    OUR_CHOICE = 'our_choice',
    POPULAR = 'popular',
    DISCOUNT = 'discount',
    REVIEWS_RATING = 'reviews_rating',
    EXPERTS_RATING = 'experts_rating',
    PRICE_UP = 'price_up',
    PRICE_DOWN = 'price_down',
    PURCHASE = 'purchase',
    NEW = 'new',
    LOW = 'low',
    HIGH = 'high',
}
